import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// import { setSwitchToChartEvents } from '../../store/entities/superFeedEvents';
// import Paginator from '../common/paginator/paginator';
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';
//import { Card, Table } from 'react-bootstrap'
//import { FaDesktop, FaMobileAlt } from 'react-icons/fa'
import Tooltip from '../common/popover/tooltip';
import { formatDetectionDatetime } from '../../utilities/datetime';
import UpdatePopover from '../common/popover/updatePopover';
import EnterIcon from '../../assets/Enter_Arrow_Right.svg';
import './ListView.scss';

const ListView = (props) => {
  const {
    // pageNo, 
    // pageSize,
    totalSize,
    // isLastPage,
    sortBy,
    filterBy 
  } = props;
  // console.log("ListView props", props);
  // const { offset, pageSize } = threatFilters;

  const DeviceType = new Map([
    ['D', 'Desktop'],
    ['M', 'Mobile'],
  ]);

  // const [resultsArr, setResultsArr] = useState([offset + 20])

  // useEffect(() => {
  //   if (events.length > 0) {
  //     setResultsArr([...resultsArr, offset + 20])
  //   }
  //   else if(switchToChart && tokenRoles == "CustomerAdmin"){ //We want 'switchToChart' feature only for CA
  //     handleViewSelect('chart')
  //     props.setSwitchToChartEvents()
  //   }
  // }, [events])

  // useEffect(() => {
  //   setResultsArr([offset + 20])
  // }, [
  //   props.selectedCustomer,
  //   threatFilters['endTime'],
  //   threatFilters['startTime'],
  //   threatFilters['type'],
  //   threatFilters['cleared'],
  //   threatFilters['order'],
  //   threatFilters['extensionUserId'],
  //   threatFilters['brand'],
  //   threatFilters['triagedEvent'],
  //   threatFilters['removeRepeateUrl'],
  //   threatFilters['removeThreatUrl'],
  //   threatFilters['includeFalsePositive'],
  // ])

  return (
    <>
      <div className="pageContainer">
          <div>
            <div>
              <b>
                Results ({(props.isLastPage ? totalSize : `More than ${totalSize}`) || 0})
              </b>
            </div>
            <div>
              <table className="listTable mb-5">
                <thead className="tableHead">
                  <tr>
                    <th style={{ minWidth: '300px', width: '15%' }}>User</th>
                    <th style={{ maxWidth: '250px', width: '15%' }}>Organization</th>
                    <th style={{ minWidth: '350px', width: '50%' }}>URL</th>
                    <th style={{ minWidth: '170px', width: '15%' }}>Status</th>
                    <th style={{ minWidth: '50px', width: '5%' , paddingLeft:'0px'}}>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {(props.events ? props.events : []).map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="">
                          <div className="d-flex align-items-center">
                            <span><b>{item?.userName}</b></span>
                          </div>
                          <div className="d-flex align-items-center">
                            <span style={{ color: '#2d5fa7' }}>
                              <b>{item.detectedBrands}</b>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="orgWrap" >
                          {props.getCustomerName(item?.customerId)}
                          {/* {`${props.getCustomerName(item?.customerId)?.split('>')[0]}`}
                          {props.getCustomerName(item?.customerId)?.split('>')[1] ? 
                            <> {' > '} <br />{`${props.getCustomerName(item?.customerId)?.split('>')[1]}`}</> : null} */}
                        </span>
                      </td>
                      <td>
                        <div className="textWrap urlWrap" data-tip data-for={item.url}> {item.url} </div>
                        <Tooltip id={item.url} data={item.url} />
                        <div className="textWrap urlWrap">
                          <span>
                            <i>
                              Opened at{' '}
                              {formatDetectionDatetime(item.detectedOn)}
                            </i>
                          </span>
                        </div>
                      </td>
                      <td>
                        {<span className={props.getStatusClass(item.status)}>
                            <b>{item.status}</b> 
                        </span>}
                        <UpdatePopover
                          {...props}
                          role={props.tokenRoles}
                          event={item}
                          from={"superFeedList"}
                        />
                      </td>
                      <td>
                        <img
                          className="rowDetail"
                          onClick={() => props.onDetails(item)}
                          src={EnterIcon}
                          alt="next-icon"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => ({
  // events: state.entities.superFeedEvents.list,
  superFeedEventsLoading: state.entities.superFeedEvents.loading,
  isLastPage: state.entities.superFeedEvents.isLastPage,
  selectedCustomer: state.entities.customers.selected
})

const mapDispatchToProps = (dispatch) => ({
  // loadNextEvents: (offset, selectedId, defaultCustomerId, isGlobalView) => dispatch(loadNextEvents(offset, selectedId, defaultCustomerId, isGlobalView)),
  // loadPrevEvents: (offset, selectedId, defaultCustomerId, isGlobalView) => dispatch(loadPrevEvents(offset, selectedId, defaultCustomerId, isGlobalView)),
  // setSwitchToChartEvents : () => dispatch(setSwitchToChartEvents())
})

export default connect(mapStateToProps, mapDispatchToProps)(ListView)
